import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 3vh;

  animation: fadein 0.5s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Text = styled.span`
  color: #616a7b;
  font-size: 3.5vw;
`;

export const Link = styled.div`
  border-radius: 5px;
  border-radius: 17.02px;
  height: 13.026819923371647vh;
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8vh;
  color: white;
  font-weight: bold;
  font-size: 4vw;
  cursor: pointer;
  background: ${(props) => props.btnColor};

  &:hover {
    background: ${(props) => props.btnHoverColor};
  }
`;
